<template>
  <div class="text-center">
    <v-dialog
      persistent
      v-model="showTutorialVideo"
      :width="$vuetify.breakpoint.smAndDown ? '90%' : '60%'"
    >
      <v-card>
        <video
          width="100%"
          height="290"
          controls
          autoplay
          v-if="showTutorialVideo"
        >
          <source
          src="https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F1.%20Prosic.App_Presentaci%C3%B3nApp.mp4?alt=media&token=51d752df-cf76-4baf-9461-f6f7b6ca5466"
          type=video/mp4>
        </video>
        <v-card v-else height="290"> </v-card>
        <div class="text-center">
          <v-btn
            color="accent"
            class="mb-2"
            to="/tutoriales"
            @click="changeVideoTutorial(false)"
          >
            Ver tutoriales
          </v-btn>
        </div>

        <v-btn
          icon
          color="accent"
          absolute
          right
          top
          @click="changeVideoTutorial(false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("user", ["changeVideoTutorial"])
  },
  computed: {
    ...mapState("user", ["showTutorialVideo"])
  }
};
</script>
